module.exports = __webpack_public_path__ + "media/applications/components/HeaderApp/assets/chevron-cfef28358ba52c80b45f10f298cf63d0.svg";